export { default } from './Confirm2FactorReset';
